import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchFlows } from "redux/actions/portal/flowsActionCreator";

export const usePortalFlows = (shouldFetch = true) => {
  const { user } = useAuth0();
  const { flows, areFlowsLoaded, isLoadingPortalFlows } = useSelector(
    (store) => store?.portal?.flows
  );
  const dispatch = useDispatch();

  const handleFetchFlows = () => dispatch(fetchFlows(user?.stripeId));

  useEffect(() => {
    if (!user?.stripeId || flows.length || !shouldFetch) return;

    handleFetchFlows();
  }, [user?.stripeId, shouldFetch]);

  return {
    flows,
    handleFetchFlows,
    areFlowsLoaded,
    isLoadingPortalFlows
  };
};
